import { render } from "./relatedForum.vue?vue&type=template&id=82bcecb2"
import script from "./relatedForum.vue?vue&type=script&lang=js"
export * from "./relatedForum.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/relatedForum.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82bcecb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82bcecb2', __exports__)) {
    console.log('reload')
    api.reload('82bcecb2', __exports__)
  }
  
  module.hot.accept("./relatedForum.vue?vue&type=template&id=82bcecb2", () => {
    console.log('re-render')
    api.rerender('82bcecb2', render)
  })

}


export default __exports__